"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const TitleApp_vue_1 = __importDefault(require("./TitleApp.vue"));
const title_1 = require("./store/title");
vue_1.default.config.productionTip = false;
new vue_1.default({
    render: (h) => h(TitleApp_vue_1.default),
    store: title_1.store,
}).$mount('#app');
